import {
    LOGIN_USER,
    LOGIN_SUCCESS,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
    SET_TOKEN
} from "./actionTypes"

export const loginUser = (data, history, from) => {
    return {
        type: LOGIN_USER,
        payload: { data, history, from }
    }
}

export const setToken = (token) => {
    return {
        type: SET_TOKEN,
        data: token
    }
}

export const loginSuccess = (user) => {
    return {
        type: LOGIN_SUCCESS,
        data: user
    }
}

export const logoutUser = (history) => {
    return {
        type: LOGOUT_USER,
        payload: { history }
    }
}

export const logoutUserSuccess = () => {
    return {
        type: LOGOUT_USER_SUCCESS,
        payload: {}
    }
}
